"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CalendarIcon = function CalendarIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$filled = _ref.filled,
      filled = _ref$filled === void 0 ? false : _ref$filled,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["color", "size", "filled", "className", "children"]);

  var classes = 'calcite-icon';
  if (className) classes += " ".concat(className);

  if (size <= 16) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 16 16",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M16 16H0V6h16zM3 7H1v2h2zm3 0H4v2h2zm3 0H7v2h2zm3 0h-2v2h2zm3 0h-2v2h2zM3 10H1v2h2zm3 0H4v2h2zm3 0H7v2h2zm3 0h-2v2h2zm3 0h-2v2h2zM3 13H1v2h2zm3 0H4v2h2zm3 0H7v2h2zm3 0h-2v2h2zm3 0h-2v2h2zm1-12v4H0V1h2v2h3V1h6v2h3V1zM4 0H3v2h1zm9 0h-1v2h1z"
    }) : _react["default"].createElement("path", {
      d: "M14 3v2H1V3h1V2H0v12h15V2h-2v1zm0 10H1V6h13zM5 3V2h5v1zM4 1v2H3V1zm7 2V1h1v2z"
    }));
  }

  if (size <= 24) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M22 22H1V9h21zM5 10H2v3h3zm4 0H6v3h3zm4 0h-3v3h3zm4 0h-3v3h3zm4 0h-3v3h3zM5 14H2v3h3zm4 0H6v3h3zm4 0h-3v3h3zm4 0h-3v3h3zm4 0h-3v3h3zM5 18H2v3h3zm4 0H6v3h3zm4 0h-3v3h3zm4 0h-3v3h3zm4 0h-3v3h3zm1-15.974V8H1V2.026h3V4h3V2.026h9V4h3V2.026zM6 1H5v2h1zm12 0h-1v2h1z"
    }) : _react["default"].createElement("path", {
      d: "M19 5h2v4H2V5h2V4H1v17h21V4h-3zm2 15H2V10h19zM7 5V4h9v1zM5 6V3h1v3zm12 0V3h1v3z"
    }));
  }

  return _react["default"].createElement("svg", _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 32 32",
    className: classes
  }), filled ? _react["default"].createElement("path", {
    d: "M3 14v16h26V14zm5 15H4v-4h4zm0-5H4v-4h4zm0-5H4v-4h4zm5 10H9v-4h4zm0-5H9v-4h4zm0-5H9v-4h4zm5 10h-4v-4h4zm0-5h-4v-4h4zm0-5h-4v-4h4zm5 10h-4v-4h4zm0-5h-4v-4h4zm0-5h-4v-4h4zm5 10h-4v-4h4zm0-5h-4v-4h4zm0-5h-4v-4h4zm1-15v9H3V4h5v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V4h10v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V4zm-6-2h-1v4h1zM10 2H9v4h1z"
  }) : _react["default"].createElement("path", {
    d: "M10 7V6h11v1zm19-1v21H2V6h5v1H3v5h25V7h-4V6zm-1 7H3v13h25zm-5-5V4h-1v4zM9 8V4H8v4z"
  }));
};

var _default = CalendarIcon;
exports["default"] = _default;